import { gql } from '@apollo/client';

export const PropertyInfo = gql`
  query PropertyInfo($addressId: String!) {
    property {
      property(input: { addressId: $addressId }) {
        addressId
        bathroomsHalf
        bathroomsFull
        bedrooms
        city
        displaySlug
        listPrice
        listingMetadata {
          tags
          buyDirectDiscountPercent
        }
        odMarketIdentifier
        opendoorOwned
        photos(pageInput: { first: 1 }) {
          edges {
            node {
              urls {
                fullSize
              }
            }
          }
        }
        postalCode
        sellerDisclosuresDownloadUrl
        sqFtLot
        sqFtTotalLiving
        sqFtAboveGrade
        fhaEligibleDate
        state
        street
      }
    }
  }
`;
